// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_e4-2";
export var aiChatCartContainerExit = "_e4-4";
export var aiChatContainerLarge = "_e4-0";
export var aiChatContainerSmall = "_e4-1";
export var aiChatIcon = "_e4-6";
export var slideInFromRight = "_e4-3";
export var slideOutToRight = "_e4-5";